import React, { forwardRef } from 'react';
import MDPreview from '@uiw/react-markdown-preview';
import { string } from 'prop-types';

export const MarkdownView = forwardRef(
    (
        {
            value,
            ...props
        },
        ref,
    ) => {
        return (
            <div ref={ref} {...props}>
                <MDPreview data-color-mode="light" source={value} />
            </div>
        );
    },
);

MarkdownView.propTypes = {
    value: string,
};